/**
 * TanStack Query hooks for `advertiser-manager`. Thin wrappers over ./api.
 */
import {
	useMutation,
	useQuery,
	useQueryClient,
	type UseMutationResult,
	type UseQueryResult,
} from "@tanstack/react-query";
import {
	create,
	list,
	remove,
	advertiserManagerQueryKeys,
	type CreateAdvertiserManagerBody,
	type ListAdvertiserManagerResponse,
	type AdvertiserManagerRow,
} from "./api";

export function useAdvertiserManagerList(): UseQueryResult<ListAdvertiserManagerResponse, Error> {
	return useQuery({
		queryKey: advertiserManagerQueryKeys.list(),
		queryFn: list,
	});
}

export function useAdvertiserManagerCreate(): UseMutationResult<AdvertiserManagerRow, Error, CreateAdvertiserManagerBody> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: create,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserManagerQueryKeys.all });
		},
	});
}

export function useAdvertiserManagerDelete(): UseMutationResult<{ removed: boolean }, Error, string> {
	const qc = useQueryClient();
	return useMutation({
		mutationFn: remove,
		onSuccess: () => {
			qc.invalidateQueries({ queryKey: advertiserManagerQueryKeys.all });
		},
	});
}
